import { render, staticRenderFns } from "./InplayCartNew.vue?vue&type=template&id=284b05e6&scoped=true"
import script from "./InplayCartNew.vue?vue&type=script&lang=js"
export * from "./InplayCartNew.vue?vue&type=script&lang=js"
import style0 from "./InplayCartNew.vue?vue&type=style&index=0&id=284b05e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284b05e6",
  null
  
)

export default component.exports